
/*
 *   File : breadcrumb.js
 *   Author URI : https://evoqins.com
 *   Description : UI component to page navigation
 *   Integrations : null
 *   Version : v1.1
 */


import { memo } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import Icon from "../Icon/icon";

export default memo(BreadCrumb);
function BreadCrumb(props) {

    const navigator = useNavigate();
    const location = useLocation();

    // handle breadcrumb node click 
    function _handleRedirection (url, index) {
        // return when clicking current page
        if (props.redirectToTab === true && index === data.length-2) {
            navigator(url, { state: { tab: location.state.tabIndex } })
        }else{
            navigator(url);
        }
    };

    // props;
    let { data } = props;

    return (
        <p className={`mb-0 ${props.className} mt-sm-0 mt-3`}>
            {data.map((page, index) => (
                <span key={index} className={` e-font-12 ${index !== data.length - 1 ? 'e-poppins-regular color-gray cursor-pointer e-active-breadcrumb' : 'color-black e-poppins-medium'}`}
                    onClick={()=>{if (index < data.length-1) _handleRedirection(page.url, index)}}>
                    {page.page}
                    {
                        index !== data.length - 1 && 
                            <Icon icon="gray-right-arrow" size={16} />
                    }
                </span>
            ))}
        </p>
    )
}